import { render, staticRenderFns } from "./RelAgendaAusentes.vue?vue&type=template&id=b093e8be"
import script from "./RelAgendaAusentes.vue?vue&type=script&lang=js"
export * from "./RelAgendaAusentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports